<template>
    <v-form
        ref="refFormLogin"
        v-model="formLogin.valid"
        lazy-validation
        @submit.prevent="login"
        transition="slide-x-transition"
    >
        <v-card
            :loading="loading"
            outlined
            class="v-card--custom"
        >
            <v-card-text>
                <v-text-field
                    type="text"
                    name="login"
                    label="Login"
                    append-icon="person"
                    v-model="formLogin.model.username"
                    :rules="formLogin.rules.username"
                    required
                ></v-text-field>

                <v-text-field
                    type="password"
                    name="password"
                    label="Password"
                    append-icon="lock"
                    v-model="formLogin.model.password"
                    :rules="formLogin.rules.password"
                    required
                ></v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    text
                    @click="changeForm(false)"
                    class="d-block d-sm-inline"
                    small
                >Esqueci minha senha</v-btn>

                <v-spacer></v-spacer>

                <v-btn
                    type="submit"
                    color="primary"
                    class="d-block d-sm-inline"
                    :disabled="!formLogin.valid"
                    :loading="loading"
                    large
                    @click.prevent="login()"
                >Login</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
export default {
    name: 'form-login',
    props: ['loading'],
    data: () => ({
        formLogin: {
            valid: true,
            model: {
                username: '',
                password: ''
            },
            rules: {
                username: [
                    v => !!v || 'Username é obrigatório',
                    v => /.+@.+/.test(v) || 'Utilize um e-mail válido'
                ],
                password: [
                    v => !!v || 'Password é obrigatório'
                ]
            }
        }
    }),
    methods: {
        changeForm (boolean) {
            this.$emit('change-form', boolean)
        },
        login () {
            if (this.$refs.refFormLogin.validate()) {
                this.$emit('login', this.formLogin.model)
            }
        }
    }
}
</script>
